module.exports = __webpack_public_path__ + "img/face-device.20fbdf4c.png";